import React from "react";
import * as Icons from "lucide-react";

const Icon = ({ name, className, size = 24 }) => {
  const LucideIcon = Icons[name];
  if (!LucideIcon) {
    return null;
  }
  return <LucideIcon className={className} size={size} />;
};

export default Icon;
